
import { Vue, Component, Prop } from 'vue-property-decorator'
import StudentHomeApi from '@/apis/ktpStudentHome/index';
import { MyVipCardValid } from '@/interfaces/vuexStateInterface';
import moment from 'moment';
import { TrackLogType } from '@/interfaces/paycoursetracklog';
  
//即将上新的列表
@Component({
  name: 'shelfSoonLists',
  components: {

  },
  props: {

  }
})
export default class shelfSoonLists extends Vue {
  @Prop(({ default: '54px' }))  paddingTop!: string;
  @Prop(({ default: '即将上新' }))  bigTitle!: string;
  moment=moment;
  private currentTime:number = Date.now()/1000;
  private shelfSoon: any = {};
  
  created() {
      this.getShelfSoon();
  }

  mounted(){
    this.currentTime = Date.now()/1000;
  }

  getShelfSoon() {
    let params = {
      source: '1',
      offset: '6',
    };
    StudentHomeApi.getShelfSoon(params).then((res: any) => {
       this.shelfSoon = res
    });
  }
}
